// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"351":"commons","678":"component---src-pages-index-js","989":"component---src-templates-blog-post-js"}[chunkId] + "-" + {"351":"df9d3220cebc4c588310","678":"138e4bb1f9bccc297b70","989":"a8a569134945447bc927"}[chunkId] + ".js";
};